import React from 'react';

import SvgIcon from '../SvgIcon/SvgIcon';

function ErrorIcon(props) {
    return (
        <SvgIcon {...props}>
            <path clipRule="evenodd" d="M13.9393 4.11111C13.0774 2.62963 10.9226 2.62963 10.0607 4.11111L2.30336 17.4444C1.44143 18.9259 2.51884 20.7778 4.24269 20.7778H19.7573C21.4812 20.7778 22.5586 18.9259 21.6966 17.4444L13.9393 4.11111ZM10.8889 7.44439H13.1111V14.1111H10.8889V7.44439ZM10.8889 16.3333H13.1111V18.5556H10.8889V16.3333Z" fillRule="evenodd" />
        </SvgIcon>
    );
}

export default ErrorIcon;
